import Image from "next/image";
import { formatNumber } from "./BootcampTabs";

export default function Instructor({
  teacher,
  years,
  starRating,
  reviews,
  students,
}: any) {
  return (
    <div className="flex flex-col mt-[32px] md:gap-2 items-start justify-center text-black w-full lg:bg-white lg:p-[32px] md:rounded-[8px] font-lato">
      <div className="flex items-center justify-center space-x-[32px] md:space-x-2">
        <Image
          src={teacher?.photo}
          width={135}
          height={135}
          priority
          className="w-full aspect-square max-w-[103px] md:max-w-[135px] rounded-full object-cover object-top"
          alt="teacher's photo"
        />
        <div className="flex flex-col justify-center md:justify-start items-center">
          <p className="font-semibold w-full text-xl mb-2 md:mb-4 md:text-left">
            {teacher?.name} <br />{" "}
            <span className="text-gray-600 text-sm">Astrology Expert</span>
          </p>

          <div className="flex flex-col justify-start items-start">
            <div className="flex flex-col lg:flex-row lg:space-x-4 lg:items-center items-start justify-center text-[#484848] leading-tight flex-wrap">
              {starRating ? (
                <div className="flex space-x-1">
                  <Image
                    src="/astro/star-filled.svg"
                    width={20}
                    height={20}
                    alt="star"
                  />
                  <p>{starRating}/5 Stars</p>
                </div>
              ) : null}
              {years ? (
                <div className="flex space-x-1">
                  <Image
                    src="/astro/star-filled.svg"
                    width={20}
                    height={20}
                    alt="star"
                  />
                  <p>{years}+ years of experience</p>
                </div>
              ) : null}
              {students ? (
                <div className="flex mt-2 md:mt-0 space-x-1">
                  <Image
                    src="/astro/star-filled.svg"
                    width={20}
                    height={20}
                    alt="star"
                  />
                  <p>
                    {formatNumber(students === 0 ? 10000 : students)}+ students
                    taught
                  </p>
                </div>
              ) : null}
              {reviews ? (
                <div className="flex mt-2 md:mt-0 space-x-1">
                  <Image
                    src="/astro/star-filled.svg"
                    width={20}
                    height={20}
                    alt="star"
                  />
                  <p>{formatNumber(reviews)}+ reviews</p>
                </div>
              ) : null}
            </div>
            <div className="text-left text-[14px] mt-[14px] hidden lg:flex text-[#6E7485] tracking-wider">
              {teacher?.bio}
            </div>
          </div>
        </div>
      </div>
      <p className="font-lato text-left tracking-wider px-2 mt-4 lg:hidden text-[#484848]">
        {teacher?.bio}
      </p>
    </div>
  );
}

const AchievementItem = ({
  icon,
  text,
}: {
  icon: React.ReactNode;
  text: string;
}) => {
  return (
    <div className="flex items-center space-x-2">
      {icon}
      <p className="text-md text-muted-foreground">{text}</p>
    </div>
  );
};
